/** SQL fragments compartidos entre listado y agregados de ventas. */
export const SALE_IS_ACTIVE = "COALESCE(status, 'active') = 'active'";
export const SALE_IS_ACTIVE_S = "COALESCE(s.status, 'active') = 'active'";

/** Filtro de listado: ventas con operador sin asignar (alineado a RPC `__NULL_CASHIER__`). */
export const CASHIER_LIST_FILTER_NULL = '__NULL_CASHIER__';
